// extracted by mini-css-extract-plugin
module.exports = {"LeftArrow":"PhotoSlideShow_LeftArrow__3abyb","RightArrow":"PhotoSlideShow_RightArrow__2DQg9","slide":"PhotoSlideShow_slide__3JXmV","border":"PhotoSlideShow_border__1IcZ8"};